import PropTypes from 'prop-types'

import Badge, {atomBadgeDesigns, atomBadgeSizes, atomBadgeTypes} from '@s-ui/react-atom-badge'

import {BASE_CLASS} from '../settings.js'
import {ColorCircle} from './ColorCircle.js'

export function StepTags({tags = [], color}) {
  const hasTags = tags.filter(Boolean).length > 0
  const hasColor = Boolean(color)

  if (!hasTags && !hasColor) return null

  return (
    <div className={`${BASE_CLASS}-tags`}>
      {tags.filter(Boolean).map((label, index) => (
        <Badge
          key={`${index}-${label}`}
          design={atomBadgeDesigns.SOFT}
          label={label}
          size={atomBadgeSizes.LARGE}
          type={atomBadgeTypes.PRIMARY}
        />
      ))}
      {hasColor && <ColorCircle color={color} size="small" />}
    </div>
  )
}

StepTags.displayName = 'StepperFlowStepTags'
StepTags.propTypes = {
  color: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string)
}
